import moment from 'moment';

export default {
  // NOTE: name is singular
  name: 'user',
  uniqKey: '_id',
  crudMapping: {
    readMany: 'users',
    readOne: 'user',
    create: 'createUser',
    update: 'updateUser',
  },
  readManySchema: {
    cellFormatter(value, object, fieldName) {
      if (fieldName === '_id') {
        const date = new Date(parseInt(value.substring(0, 8), 16) * 1000);
        return moment(date).format('MM/DD/YYYY');
      }
      if (fieldName === 'companyIds') {
        return value
          .reduce(
            (acc, companyName) =>
              (acc.includes(companyName) ? acc : [...acc, companyName]),
            [],
          )
          .join(', ');
      }

      return value;
    },
    showTotal: true,
    jsonSchema: {
      type: 'object',
      properties: {
        fullName: {
          type: 'string',
        },
        email: {
          type: 'number',
        },
        companyIds: {
          type: 'string',
          title: 'Companies',
        },
        _id: {
          type: 'string',
          title: 'Signed up At',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      description:
        'Complete all required* fields below. You may Save or Publish this user. Your progress will not be saved if you exit the page.',
      type: 'object',
      required: ['fullName', 'email', 'roles'],
      properties: {
        basics: {
          type: 'string',
          title: 'Basics',
          displayOnly: true,
        },
        fullName: {
          type: 'string',
          title: 'Full Name',
          description: "What is the user's name?",
        },
        email: {
          type: 'string',
          title: 'Email',
          description: "What is the user's email?",
        },
        roles: {
          type: 'string',
          enum: ['USER', 'ADMIN', 'EDITOR', 'CURATOR'],
          enumNames: ['User', 'Admin', 'Editor', 'Curator'],
          title: 'Roles',
          description: 'Does the user have any role?',
        },
        freeSubscriptionCompanyIds: {
          type: 'array',
          default: [],
          items: {
            type: 'string',
          },
          title: 'Offered curator libraries',
        },
        isAffiliate: {
          type: 'boolean',
          title: 'Should be Included in Commission program (Curator only)',
          default: true,
        },
        tapfiliate: {
          title: 'Tapfiliate',
          type: 'object',
          properties: {
            id: {
              type: 'string',
            },
          },
        },
      },
    },
    uiSchema: {
      basics: {
        'ui:widget': 'sectionWidget',
      },
      freeSubscriptionCompanyIds: {
        'ui:field': 'hasManyField',
      },
      tapfiliate: {
        id: {
          'ui:readonly': true,
        },
      },
    },
  },
  updateSchema: {
    jsonSchema: {
      description:
        'Complete all required* fields below. You may Save or Publish this user. Your progress will not be saved if you exit the page.',
      type: 'object',
      required: ['fullName', 'email'],
      properties: {
        basics: {
          type: 'string',
          title: 'Basics',
          displayOnly: true,
        },
        fullName: {
          type: 'string',
          title: 'Full Name',
          description: "What is the user's name?",
        },
        email: {
          type: 'string',
          title: 'Email',
          description: "What is the user's email?",
        },
        roles: {
          type: 'string',
          title: 'Roles',
          description: 'Does the user have any role?',
          enum: ['USER', 'ADMIN', 'EDITOR', 'CURATOR'],
          default: 'USER',
          enumNames: ['User', 'Admin', 'Editor', 'Curator'],
        },
        freeSubscriptionCompanyIds: {
          type: 'array',
          default: [],
          items: {
            type: 'string',
          },
          title: 'Offered curator libraries',
        },
        isAffiliate: {
          type: 'boolean',
          title: 'Should be Included in Commission program',
        },
        tapfiliate: {
          title: 'Tapfiliate',
          type: 'object',
          properties: {
            id: {
              type: 'string',
            },
          },
        },
      },
    },
    uiSchema: {
      basics: {
        'ui:widget': 'sectionWidget',
      },
      freeSubscriptionCompanyIds: {
        'ui:field': 'hasManyField',
      },
      isAffiliate: {
        'ui:disabled': true,
      },
      tapfiliate: {
        id: {
          'ui:readonly': true,
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/user.js